import React , { Component } from 'react';
import {Link} from 'react-router-dom';
import logo from '../../assets/images/sharework-logo1web.png';


class Logo extends Component {
    handleClick = () => {
        if (window.location.pathname === '/') {
            window.location.reload();
        }
    };
    render(){
        return (
            <div className="logo " style={{marginTop:'0px'}} >
                <Link to={"/"} onClick={this.handleClick} ><img className="logo_img" alt="Company Logo" src={logo} /></Link>
            </div>
        );
    }
}

export {Logo};
